export default "__VITE_ASSET__CBE00_LV__"